var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 69 69",
    style: {
      enableBackground: "new 0 0 69 69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_515_5059_1_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_circle_right"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 9,
    y: 9.2,
    width: 51,
    height: 51
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9.2,
    width: 51,
    height: 51,
    id: "mask0_515_5059_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.7,
    className: "st0",
    width: 68,
    height: 68
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_circle_right_2",
    d: "M34.5,44.1l9.3-9.3l-9.3-9.3l-2,2l5.9,5.9H24.6v2.8h13.9l-5.9,6L34.5,44.1z M34.5,60.2 c-3.5,0-6.8-0.7-9.9-2c-3.1-1.3-5.8-3.2-8.1-5.4c-2.3-2.3-4.1-5-5.5-8.1c-1.3-3.1-2-6.4-2-9.9c0-3.5,0.7-6.8,2-9.9 c1.3-3.1,3.2-5.8,5.4-8.1c2.3-2.3,5-4.1,8.1-5.5c3.1-1.3,6.4-2,9.9-2s6.8,0.7,9.9,2c3.1,1.3,5.8,3.2,8.1,5.4 c2.3,2.3,4.1,5,5.5,8.1c1.3,3.1,2,6.4,2,9.9s-0.7,6.8-2,9.9c-1.3,3.1-3.2,5.8-5.4,8.1c-2.3,2.3-5,4.1-8.1,5.5 C41.3,59.6,38,60.2,34.5,60.2z M34.5,57.4c6.3,0,11.7-2.2,16.1-6.6c4.4-4.4,6.6-9.8,6.6-16.1S55,23,50.6,18.7 c-4.4-4.4-9.8-6.6-16.1-6.6s-11.7,2.2-16.1,6.6c-4.4,4.4-6.6,9.8-6.6,16.1s2.2,11.7,6.6,16.1C22.8,55.2,28.2,57.4,34.5,57.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/arrow_circle_right.8aaed2c91248be00f6174cf575d38f48.svg";
export { ForwardRef as ReactComponent };